import { features } from '@/mocks/home';
import { brandInfo } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide mb-4">
            核心优势
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            为什么选择 aiye
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base leading-relaxed">
            {brandInfo.description}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, idx) => (
            <div
              key={feature.id}
              className="group p-6 md:p-7 rounded-2xl bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer"
              style={{ animationDelay: `${idx * 80}ms` }}
            >
              <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-xl text-accent-700`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}